import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { KYMW1300SelectedListComponent } from './kymw1300-selected-list.component';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1308Module } from '../../kymw1308/kymw1308.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
 * 商品企画マスタ画面　選定済一覧 モジュール設定クラス
 *
 * @export KYMW1300SelectedListModule
 * @class KYMW1300SelectedListModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    KYMW1308Module,
    FontAwesomeModule,
  ],
  declarations: [
    KYMW1300SelectedListComponent,
  ],
  providers: [
    KYMW1300Model,
  ],
  exports: [
    KYMW1300SelectedListComponent,
  ]
})
export class KYMW1300SelectedListModule {
}
